/**
 *  Normalize strings and remove special chars to better compare
 */
function removeAccents(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default removeAccents;
